import React, { Dispatch, SetStateAction } from 'react';
import { Button, Typography } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import { useNavigate } from 'react-router-dom';

import { dialogContent, paperProps } from './SuccessModal.sx';
import SuccessIcon from 'app/components/Icons/SuccessIcon';

interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  successText: string;
  redirect?: string;
  closeAction?: () => void;
}

const SuccessModal = (props: Props) => {
  const { open, close, successText, redirect, closeAction } = props;
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: paperProps,
      }}
      onClose={() => {
        close(false);
      }}
    >
      <DialogContent sx={dialogContent}>
        <SuccessIcon sx={{ width: '64px', height: '64px' }} />
        <Typography sx={{ fontSize: '26px', fontWeight: 600, textAlign: 'center' }}>{successText}</Typography>

        <Button
          sx={{ width: '100%' }}
          onClick={() => {
            close(false);
            if (closeAction) {
              closeAction();
            }
            if (redirect) {
              navigate(redirect);
            }
          }}
          color={'secondary'}
        >
          Bağla
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;
